import React from 'react';

import ManagerLayout from 'app/developer-v3/layouts/ManagerLayout';
import { useDismissable, usePrivatePlatform } from 'app/developer-v3/hooks';

import CLI from './CLI';
import GUI from './GUI';
import PlatformVersionMessage from './PlatformVersionMessage';

import { AppFormType, AppSummary } from 'app/developer-v3/types';
import type { ZapTaskDetails } from './types';

type Props = {
  appSummary: AppSummary;
  hasActions: boolean;
  hasAuthentication: boolean;
  hasSearches: boolean;
  hasTriggers: boolean;
  integrationSettings: AppFormType;
  isPrivate: boolean;
  isStaff: boolean;
  params: { appId: number; version: string };
  setIntentionPublic: (integrationSettings: AppFormType) => Promise<void>;
  zapTaskDetails: ZapTaskDetails;
};

function VersionOverviewPage({
  appSummary,
  hasActions,
  hasSearches,
  hasTriggers,
  hasAuthentication,
  integrationSettings,
  isPrivate,
  params: { appId, version },
  setIntentionPublic,
  zapTaskDetails,
}: Props) {
  const {
    isPublicIntention,
    isPublicIntentionElementVisible,
  } = usePrivatePlatform();

  const {
    dismiss: dismissPrivateIntentionMsg,
    isVisible: isPrivateIntentionMsgVisible,
  } = useDismissable({ persistId: 'developer-home-private-intention-message' });

  const onConfirmPublicIntention = () =>
    setIntentionPublic({ ...integrationSettings, intention: 'global' });

  return (
    <ManagerLayout title="Version Overview">
      {appSummary?.platformVersion && (
        <PlatformVersionMessage
          isCLI={!appSummary.isGUIIntegration}
          platformVersion={appSummary.platformVersion}
          version={version}
        />
      )}
      {appSummary?.isGUIIntegration ? (
        <GUI
          hasActions={hasActions}
          hasAuthentication={hasAuthentication}
          hasSearches={hasSearches}
          hasTriggers={hasTriggers}
          integrationId={appId}
          isPrivate={isPrivate}
          isPrivateIntentionMsgVisible={isPrivateIntentionMsgVisible}
          isPublicIntention={isPublicIntention}
          isPublicIntentionElementVisible={isPublicIntentionElementVisible}
          onConfirmPublicIntention={onConfirmPublicIntention}
          onDismissPrivateIntentionMsg={dismissPrivateIntentionMsg}
          userCount={appSummary.users.count}
          version={version}
          zapTaskDetails={zapTaskDetails}
        />
      ) : (
        <CLI
          isPrivateIntentionMsgVisible={isPrivateIntentionMsgVisible}
          isPublicIntention={isPublicIntention}
          isPublicIntentionElementVisible={isPublicIntentionElementVisible}
          onConfirmPublicIntention={onConfirmPublicIntention}
          onDismissPrivateIntentionMsg={dismissPrivateIntentionMsg}
        />
      )}
    </ManagerLayout>
  );
}

export default VersionOverviewPage;
